/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorTicketDto } from '../../models/vendor-ticket-dto';

export interface VendorTicketControllerFindAll$Params {
}

export function vendorTicketControllerFindAll(http: HttpClient, rootUrl: string, params?: VendorTicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorTicketDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorTicketControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorTicketDto>>;
    })
  );
}

vendorTicketControllerFindAll.PATH = '/api/vendor-ticket';
